import { createSelector } from 'reselect'
import { selectCurrentCELs, selectFromCurrentCELs } from './dictionary'

export const selectRefiStatus = createSelector(
  selectCurrentCELs,
  dict => ({
    fha: dict.showRefiForFHA(),
    isConsolidation: dict.isConsolidation()
  })
)

export const selectFullLoanTotal = selectFromCurrentCELs(
  'interestForFullLoanTotal'
)
